<script setup lang="ts">
  import { Spinner } from "@/components/ui/spinner";
  import AiReviewToolbar from "./AiReviewToolbar.vue";
  import type { AiMode } from "./types";

  withDefaults(
    defineProps<{
      mode: AiMode;
      label?: string;
      showOriginal?: boolean;
    }>(),
    {
      label: "Generating",
      showOriginal: false,
    },
  );

  defineEmits<{
    accept: [];
    toggle: [];
    retry: [];
    cancel: [];
  }>();
</script>

<template>
  <div
    v-if="mode !== 'idle'"
    class="flex items-center gap-2">
    <div
      v-if="mode === 'generating'"
      class="inline-flex items-center gap-1 rounded-md border border-transparent px-1.5 py-1">
      <span class="flex h-7 items-center gap-1.5 px-2 text-xs text-muted-foreground">
        <Spinner class="size-3.5" />
        {{ label }}
      </span>
    </div>
    <AiReviewToolbar
      v-else
      :show-original="showOriginal"
      @accept="$emit('accept')"
      @toggle="$emit('toggle')"
      @retry="$emit('retry')"
      @cancel="$emit('cancel')" />
  </div>
</template>
